import React from "react";
import { Grid, Typography } from "@mui/material";
// import publications from "../../../../assets/svgs/publicationsRemake.svg";
// import publications from "../../../../assets/svgs/publicationsRemake2.png";
import publications from "../../../../assets/svgs/CITIISpublications.PNG";
// import homevids from "../../../../assets/svgs/videosRemake.svg";
// import homevids from "../../../../assets/svgs/videosRemake2.png";
import homevids from "../../../../assets/svgs/CITIISvideos.PNG";
// import homeblogs from "../../../../assets/svgs/blogsRemake.svg";
// import homeblogs from "../../../../assets/svgs/blogsRemake2.png";
import homeblogs from "../../../../assets/svgs/CITIISblogs.PNG";
// import webinars from "../../../../assets/svgs/webinarsRemake.svg";
// import webinars from "../../../../assets/svgs/webinarsRemake2.png";
import webinars from "../../../../assets/svgs/CITIISwebinars.PNG";
import "./style.scss";
import { makeStyles } from "@mui/styles";
import { AOSContainer } from "../../../../common/AOSContainer";
import CustomTooltip from "../../../../common/Tooltip";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  hoverEffect: {
    transition: "all 0.5s",
    "&:hover": {
      boxShadow: theme.shadows[20],
    },
  },
}));

const useStyles2 = makeStyles((theme) => ({
  cardImageInner: (props) => ({
    width: "100%",
    transition: "all 0.5s",
    // borderTopLeftRadius: "70px",
    // borderBottomRightRadius: "70px",
    borderTopLeftRadius: "60px",
    borderBottomRightRadius: "60px",
    // borderRadius:'10px',
    cursor: "pointer",
    "&:hover": {
      boxShadow: `-4px -2px 34px 6px ${props.background}`,
    },
  }),
}));

const ImageComponent = (props) => {
  const { item } = props;
  const classes = useStyles2({ background: item.color });
  const navigate = useNavigate();

  return (
    <img
      className={classes.cardImageInner}
      onClick={() => {
        if (item.url) {
          navigate(item.url);
        }
      }}
      src={item.image}
      alt="Card cap"
    />
  );
};

const OurResources = () => {
  const classes = useStyles();

  return (
    <div className=" ourresourcesmaindiv">
      <div className="textcities1resource">
        <AOSContainer animationType="fade-right">
          <Typography variant="thinmedium" sx={{ color: "white" }}>
            Our resources
          </Typography>
        </AOSContainer>
      </div>

      <Grid container spacing={4} sx={{ marginTop: "10px" }}>
        {[
          {
            image: publications,
            // color: "#007980",
            color: "#0FD9E8",
            // color: "#10CCES",
            tooltipTitle: "Click here to view publications",
            url: "/publications",
          },
          {
            image: homevids,
            // color: "#007980",
            color: "#0FD9E8",
            // color: "#10CCES",
            tooltipTitle: "Click here to view videos",
            url: "/videos",
          },
          {
            image: homeblogs,
            // color: "#007980",
            color: "#0FD9E8",
            // color: "#10CCES",
            tooltipTitle: "Click here to view blogs",
            url: "/blogs",
          },
          {
            image: webinars,
            // color: "#007980",
            color: "#0FD9E8",
            // color: "#10CCES",
            // 10CCES
            tooltipTitle: "Click here to view webinars",
            url: "/webinars",
          },
        ].map((item, index) => (
          <CustomTooltip title={item.tooltipTitle}>
            <Grid item md={6} sm={12} key={index} className="newcardimageinner">
              <AOSContainer
                animationType={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <ImageComponent item={item} />
              </AOSContainer>
            </Grid>
          </CustomTooltip>
        ))}
      </Grid>
    </div>
  );
};

export default OurResources;
